<template>
    <layout>
        <template #content>
            <form class="w-3/4 tablet:w-full mx-auto" ref="paymentForm" method="POST">

                <input type="hidden" name="CreditCardToken" :value="mollieCreditCardToken">
                <input type="hidden" name="FirstName" :value="checkoutStore.customerDetails.firstName">
                <input type="hidden" name="LastName" :value="checkoutStore.customerDetails.lastName">
                <input type="hidden" name="Phone" :value="checkoutStore.customerDetails.phone">
                <input type="hidden" name="Email" :value="checkoutStore.customerDetails.email">
                <input type="hidden" name="RegistrationNumber" :value="checkoutStore.customerDetails.registrationNumber">
                <input type="hidden" name="VatNumber" :value="checkoutStore.customerDetails.vatNumber">
                <input type="hidden" name="Message" :value="checkoutStore.customerDetails.message">
                <input type="hidden" name="SoftwareId" :value="checkoutStore.chosenIntegration.id" v-if="checkoutStore.chosenIntegration">
                <input type="hidden" name="Features[]" :value="addon.feature" v-for="addon in checkoutStore.chosenAddons">
                <input type="hidden" name="Countries[]" :value="c.code" v-for="c in checkoutStore.selectedCountries">
                <input type="hidden" name="PaymentMethod" :value="chosenPaymentMethod">
                <input type="hidden" name="PaymentMethodId" :value="chosenPaymentMethod?.id">
                <input type="hidden" name="Check" :value="check">

                <div class=" mb-4">{{ translate('selecteer_betaalmethode') }}</div>
                <ul class="space-y-2">
                    <li v-for="method in sortedMethods"
                        @click="chosenPaymentMethod = method"
                        :class="{'border-primary-400 ring-2 ring-primary-200': method === chosenPaymentMethod}"
                        class="select-none rounded-lg border border-grey-300 cursor-pointer ">
                        <div
                            class="flex gap-3 items-center p-2 hover:bg-grey-transparent-100 active:bg-grey-transparent-200"
                            :class="{'!bg-primary-100 rounded-lg': method === chosenPaymentMethod, 'border-b border-primary-400 rounded-b-none': method.id === 'creditcard' && method === chosenPaymentMethod}">
                            <div>
                                <img :src="'/images-new/payment-methods/' + method.id + '.svg'"
                                     class="size-8 block rounded-lg border border-grey-200" :alt="method.description"/>
                            </div>
                            <div class="grow flex items-center justify-between">
                                <div>
                                    {{ translate('payment_method_' + method.id) }}
                                </div>
                                <div v-if="method.id === 'creditcard'" class="mr-3 flex items-center gap-1.5">
                                    <img src="/images-new/payment-methods/visa.png" alt="VISA"/>
                                    <img src="/images-new/payment-methods/mastercard.png" alt="Master Card"/>
                                    <img src="/images-new/payment-methods/american-express.png" alt="American Express"/>
                                </div>
                            </div>
                            <div>
                                <input type="radio" :checked="method === chosenPaymentMethod">
                            </div>
                        </div>
                        <div v-show="method.id === 'creditcard' && chosenPaymentMethod?.id === 'creditcard'"
                             class="mt-4 ml-6 mr-6 mb-6">
                            <div id="card" class="grid grid-cols-2 gap-6"></div>
                        </div>

                    </li>

                    <li @click="chosenPaymentMethod = transferMethod"
                        :class="{'border-primary-400 !bg-primary-100 ring-2 ring-primary-200': transferMethod === chosenPaymentMethod}"
                        class="select-none rounded-lg border border-grey-300 flex gap-3 items-center p-2 cursor-pointer hover:bg-grey-transparent-100 active:bg-grey-transparent-200">
                        <div>
                            <img :src="'/images-new/payment-methods/' + transferMethod.id + '.svg'"
                                 class="size-8 block rounded-lg border border-grey-200"
                                 :alt="transferMethod.description"/>
                        </div>
                        <div class="grow">
                            {{ translate('payment_method_' + transferMethod.id) }}
                        </div>
                        <div>
                            <input type="radio" :checked="transferMethod === chosenPaymentMethod">
                        </div>
                    </li>
                </ul>
                <p v-if="chosenPaymentMethod === transferMethod" class="text-grey-800 text-sm mt-4">
                    <span class="font-semibold">{{ translate('let_op') }}:</span>
                    {{ translate('overschrijving_disclaimer') }}
                </p>
            </form>
        </template>
        <template #sidebar>
            <div class="flex flex-col gap-5">
                <div>
                    <div class="flex gap-2">
                        <input id="terms" class="mt-0.5" type="checkbox" v-model="hasCheckedTerms"/>
                        <label for="terms">
                            <translation label="ik_ga_akkoord_met">
                                <a :href="termsAndConditionsLink" class="underline"
                                   target="_blank">{{ translate('algemene_voorwaarden').toLowerCase() }}</a>
                            </translation>
                        </label>
                    </div>
                    <div class="text-red-400 text-sm mt-1" v-if="!hasCheckedTerms && hasTriedSubmitting">
                        {{ translate("validation_error_required_checked") }}
                    </div>
                </div>
                <div>
                    <button class="btn btn-primary w-full" :disabled="!chosenPaymentMethod" @click.prevent="onSubmit">
                        {{ translate('betalen') }}
                    </button>
                    <button class="btn btn-ghost w-full mt-3" v-if="checkoutStore.canGoToPrevPage"
                            @click.prevent="checkoutStore.prevPage()">{{ translate('vorige') }}
                    </button>
                </div>
            </div>
        </template>
    </layout>
</template>

<script lang="ts">
import {defineComponent, nextTick} from 'vue';
import {useStore} from "../../store";
import Layout from "./layout.vue";
import Translation from "../../../../components/translation.vue";
import {PaymentMethod} from "../../types";
import Toast from "../../../../lib/Toast";

export default defineComponent({
    name: "payment",
    components: {
        Translation,
        Layout
    },
    data() {
        const lang = window.cw.language;
        const checkoutStore = useStore();
        return {
            checkoutStore:checkoutStore,
            termsAndConditionsLink: window.cw.termsAndConditionsLink,
            check: window.cw.check,
            paymentMethods: window.cw.paymentMethods as PaymentMethod[],
            hasCheckedTerms: false,
            hasTriedSubmitting: false,
            chosenPaymentMethod: null as PaymentMethod | null,
            transferMethod: {
                id: 'transfer',
                description: 'Overschrijving'
            } as PaymentMethod,
            showTransferMessage: false,
            mollieCreditCardToken: '',
            //@ts-ignore
            mollie: Mollie(checkoutStore.mollieProfileId,
                {
                    locale: lang === 'nl' 
                        ? 'nl_NL' 
                        : lang === 'fr' 
                            ? 'fr_FR' 
                            : 'en_GB',
                    testmode: checkoutStore.mollieIsTestMode
                }
            )
        }
    },
    computed: {
        sortedMethods(): PaymentMethod[] {
            return [...this.paymentMethods].sort((a, b) => a.id === 'creditcard' ? -1 : 0);
        }
    },
    methods: {
        async onSubmit() {
            this.hasTriedSubmitting = true;
            if (!this.hasCheckedTerms)
                return;

            if (this.chosenPaymentMethod?.id === 'creditcard') {
                const {token, error} = await this.mollie.createToken();
                if (error) {
                    Toast.error(error.message);
                    return;
                }

                this.mollieCreditCardToken = token;
            }

            //OTHERWISE mollieCreditCardToken is not yet set
            nextTick(() => {
                (this.$refs.paymentForm as HTMLFormElement).submit();
                localStorage.removeItem("trialRenewStart");
            });
        },
    },
    mounted() {
        // set up mollie credit card component
        const cardComponent = this.mollie.createComponent('card');
        cardComponent.mount('#card');
    }
})
</script>

<style>
.mollie-component {
    background: white;
    border-radius: 4px;
    border: 1px solid #dedfe0;
    padding: 8px 12px;
    font-size: 14px;
    color: #384143;
    width: 100%;
}

.mollie-card-component__label {
    font-weight: 500;
    margin-bottom: 4px;
    display: inline-block;
    font-size: 14px;
}

.mollie-card-component__error {
    font-size: 14px;
    color: #E22014;
}

.mollie-card-component--cardHolder, .mollie-card-component--cardNumber {
    grid-column: 1 / -1;
}
</style>